<template>
  <div class="top-bar" 
    @mousedown="mousedown"
  >
  </div>
</template>

<script>
export default {
  data() {
    return {
      /** 鼠标已经按下 */
      isMousedown: false,
      /** 鼠标移动过程中 */
      isMousemove: false,
      /** 开始移动的时候鼠标的位置 */
      startMousePoint: {
        x: '',
        y: ''
      },
      /** 开始移动的时候Window的位置 */
      startWindowPoint: {
        x: '',
        y: ''
      },
      /** 初始相对位置 */
      absolutePoint: {
        x: '',
        y: ''
      }
    }
  },
  methods: {
    /** 鼠标按下 */
    mousedown(e) {
      this.isMousedown = true
      this.startMousePoint = this.getMousePoint(e)
      this.startWindowPoint = this.getWindowPoint(e)
      this.absolutePoint.x = e.layerX
      this.absolutePoint.y = e.layerY

      const mousemoveHandler = (e) => {
        if(this.isMousedown) {
          // 获取窗口当前坐标
          const currentWindowPoint = this.getWindowPoint(e)

          // 换算VH单位
          const VH = window.innerHeight/100
          currentWindowPoint.x = currentWindowPoint.x/VH
          currentWindowPoint.y = currentWindowPoint.y/VH

          if(currentWindowPoint.y < 0) return 
          this.$emit('move', currentWindowPoint)
        }
      }
      document.addEventListener('mousemove', mousemoveHandler)

      const mouseupHandler = (e) => {
        if (this.isMousedown)  {
          this.isMousedown = false;
        }
        document.removeEventListener('mousemove', mousemoveHandler)
        document.removeEventListener('mouseup', mouseupHandler)
      }
      document.addEventListener('mouseup', mouseupHandler)
    },

    /** 获取Window对象坐标 */
    getWindowPoint(e) {
      // 计算原点位置
      const point = {
        x: e.clientX - this.absolutePoint.x, 
        y: e.clientY - this.absolutePoint.y
      }
      return point
    },
    /** 获取鼠标当前位置 */
    getMousePoint(e) {
      const point = {
        x: e.clientX,
        y: e.clientY
      }
      return point
    }
  }
}
</script>

<style lang="less" scoped>
.top-bar {
  position: absolute;
  width: 100%;
  height: 2.6vh;
  // background-image: linear-gradient(180deg, #fff 1%, rgb(64, 148, 200) 5%, rgb(76, 83, 200) 100%);
  background-image: linear-gradient(180deg, #bac 1%, rgb(138, 112, 198) 5%, rgb(95, 101, 204) 100%);
  // background-color: rgb(76, 43, 193);
  border-radius: .5vh .5vh 0 0;
  border-top: .05vh solid rgb(13, 103, 125);
  // border-left: .01vh solid rgb(13, 103, 125);
  // border-right: .01vh solid rgb(13, 103, 125);

  box-sizing: border-box;
}
</style>